import {CLEAR_NUMBER_MANAGE, FETCH_NUMBER_MANAGE, LIST_NUMBER_MANAGE} from "./types";


const init = {
    isLoading: false,
    data: null,
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_NUMBER_MANAGE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_NUMBER_MANAGE:
            return {
                ...state,
                isLoading: false,
                data: payload.data
            };
        case CLEAR_NUMBER_MANAGE:
            return {
                ...init
            };
        default:
            return state

    }
}
